import {
  BASE_API_URL,
  post,
} from '@/utils/http'

export * from './common'
export const queryOpenBatchEnrollListUrl = `${BASE_API_URL}/ykbm/queryYkBmxxCartList`
export const queryOpenBatchEnrollList = (...args) => {
  return post(queryOpenBatchEnrollListUrl, ...args)
}

// 撤销报名详情
export const cancelEnrollUrl = `${BASE_API_URL}/ykbm/cancelYkKsBmxx`
export const cancelEnroll = (...args) => {
  return post(cancelEnrollUrl, ...args)
}

// 查看报名须知
export const queryNoticeUrl = `${BASE_API_URL}/ykbm/queryBmxz`
export const queryNotice = (...args) => {
  return post(queryNoticeUrl, ...args)
}

// 查看报名详情
export const queryEnrollDetailUrl = `${BASE_API_URL}/ykbm/queryYkKsBmxxDetail`
export const queryEnrollDetail = (...args) => {
  return post(queryEnrollDetailUrl, ...args)
}

// 重新填报
export const reWriteEnrollUrl = `${BASE_API_URL}/ykbm/refillYkKsBmxx`
export const reWriteEnroll = (...args) => {
  return post(reWriteEnrollUrl, ...args)
}

// 提交
export const submitEnrollUrl = `${BASE_API_URL}/ykbm/submit`
export const submitEnroll = (...args) => {
  return post(submitEnrollUrl, ...args)
}

// 保存考生基本消息
export const insertBaseInfoUrl = `${BASE_API_URL}/ykbm/insertOrUpdateKsxx`
export const insertBaseInfo = (...args) => {
  return post(insertBaseInfoUrl, ...args)
}

// 保存家庭成员
export const insertOrUpdateFamilyUrl = `${BASE_API_URL}/ykbm/insertOrUpdateKsJtcy`
export const insertOrUpdateFamily = (...args) => {
  return post(insertOrUpdateFamilyUrl, ...args)
}

// 删除家庭成员
export const deleteFamilyUrl = `${BASE_API_URL}/ykbm/deleteKsJtcy`
export const deleteFamily = (...args) => {
  return post(deleteFamilyUrl, ...args)
}

// 查询家庭成员
export const queryFamilyUrl = `${BASE_API_URL}/ykbm/queryKsJtcyList`
export const queryFamily = (...args) => {
  return post(queryFamilyUrl, ...args)
}

// 上传附件
export const uploadAttachmentUrl = `${BASE_API_URL}/ykbm/uploadAttachment`
export const uploadAttachment = (...args) => {
  return post(uploadAttachmentUrl, ...args)
}

// 保存学习经历
export const insertOrUpdateStudyUrl = `${BASE_API_URL}/ykbm/insertOrUpdateKsXxjl`
export const insertOrUpdateStudy = (...args) => {
  return post(insertOrUpdateStudyUrl, ...args)
}

// 删除学习经历
export const deleteStudyUrl = `${BASE_API_URL}/ykbm/deleteKsXxjl`
export const deleteStudy = (...args) => {
  return post(deleteStudyUrl, ...args)
}

// 查询学习经历
export const queryStudyUrl = `${BASE_API_URL}/ykbm/queryKsXxjlList`
export const queryStudy = (...args) => {
  return post(queryStudyUrl, ...args)
}

// 上传照片
export const uploadEnrollPhotoUrl = `${BASE_API_URL}/ykbm/uploadPhoto`
export const uploadEnrollPhoto = (...args) => {
  return post(uploadEnrollPhotoUrl, ...args)
}

// 查询志愿
export const queryVolunteerUrl = `${BASE_API_URL}/ykbm/queryZyList`
export const queryVolunteer = (...args) => {
  return post(queryVolunteerUrl, ...args)
}

// 下载报名表
export const downloadEnrollTableUrl = `${BASE_API_URL}/ykbm/downloadBmb`
export const downloadEnrollTable = (...args) => {
  return post(downloadEnrollTableUrl, ...args)
}

// 保存附件
export const saveAttachmentUrl = `${BASE_API_URL}/ykbm/saveAttachment`
export const saveAttachment = (...args) => {
  return post(saveAttachmentUrl, ...args)
}

// 我的报名信息
export const queryMyEnrollListUrl = `${BASE_API_URL}/ykbm/queryBmxxList`
export const queryMyEnrollList = (...args) => {
  return post(queryMyEnrollListUrl, ...args)
}

export const updateEnrollTypeUrl = `${BASE_API_URL}/ykbm/updateKsYkzslbdm`
export const updateEnrollType = (...args) => {
  return post(updateEnrollTypeUrl, ...args)
}

export const queryCurrentEnrollBatchEnrollTypeUrl = `${BASE_API_URL}/ykbm/queryKsYkZslbdm`
export const queryCurrentEnrollBatchEnrollType = (...args) => {
  return post(queryCurrentEnrollBatchEnrollTypeUrl, ...args)
}

export const queryBatchSingleEnrollConfigUrl = `${BASE_API_URL}/ykbm/queryYkZslbConfig`
export const queryBatchSingleEnrollConfig = (...args) => {
  return post(queryBatchSingleEnrollConfigUrl, ...args)
}

// 查看缴费信息
export const queryPayInfoUrl = `${BASE_API_URL}/ykjf/queryYkKsJfxxCartList`
export const queryPayInfo = (...args) => {
  return post(queryPayInfoUrl, ...args)
}

export const queryPayNoticeUrl = `${BASE_API_URL}/ykjf/queryJfxz`
export const queryPayNotice = (...args) => {
  return post(queryPayNoticeUrl, ...args)
}

// 微信下单
export const doOrderUrl = `${BASE_API_URL}/ykjf/order`
export const doOrder = (...args) => {
  return post(doOrderUrl, ...args)
}

// 查看已缴费信息
export const queryHasFinishPayListUrl = `${BASE_API_URL}/ykjf/queryYkKsJfxxList`
export const queryHasFinishPayList = (...args) => {
  return post(queryHasFinishPayListUrl, ...args)
}

export const queryPayMethodPreUrl = `${BASE_API_URL}/zs/zd/queryPayTypeList`
export const queryPayMethodPre = (...args) => {
  return post(queryPayMethodPreUrl, ...args)
}

// 查看缴费详情
export const queryPayOrderInfoUrl = `${BASE_API_URL}/ykjf/queryYkKsJfxqList`
export const queryPayOrderInfo = (...args) => {
  return post(queryPayOrderInfoUrl, ...args)
}

export const queryTestResultUrl = `${BASE_API_URL}/yk/pc/queryYkPcjl`
export const queryTestResult = (...args) => {
  return post(queryTestResultUrl, ...args)
}

export const queryTestReadyUrl = `${BASE_API_URL}/yk/pc/queryYkPcstReady`
export const queryTestReady = (...args) => {
  return post(queryTestReadyUrl, ...args)
}

export const queryTestQuestionListUrl = `${BASE_API_URL}/yk/pc/queryYkPcstPageList`
export const queryTestQuestionList = (...args) => {
  return post(queryTestQuestionListUrl, ...args)
}

export const saveTestUrl = `${BASE_API_URL}/yk/pc/saveYkPcstDa`
export const saveTest = (...args) => {
  return post(saveTestUrl, ...args)
}

export const submitTestQuestionUrl = `${BASE_API_URL}/yk/pc/submit`
export const submitTestQuestion = (...args) => {
  return post(submitTestQuestionUrl, ...args)
}
